
































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
  loginId: string
  password: string
  isPasswordShowable: boolean
  isEntranceSite: boolean
};

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
      loginId: "",
      password: "",
      isPasswordShowable: false,
      isEntranceSite: window.location.href.includes("https://nyushi.smarky.jp/"),
    });

    // ログインボタン押下
    const onSubmit = async () => {
      state.errors = [];
      if(state.loginId.length == 0){
        state.errors.push("ログインIDを入力してください。");
        return;
      }

      if(state.password.length == 0){
        state.errors.push("パスワードを入力してください。");
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      await http.post("/api/login", {condition: {login_id: state.loginId, password: state.password}})
        .then(response => {
          if (response.data.confirm == null) {
            executeLogin(response)
          }else {
            if(window.confirm('現在、ログイン中のユーザの処理が中断されます。本当によろしいですか？')){
              http.post("/api/login", {condition: {login_id: state.loginId, password: state.password}, confirmed: true})
                .then(response => {
                  executeLogin(response)
                })
                .catch(error => {
                  if (error.response.status == 401) {
                    state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
                  }
                  if (error.response.status == 402) {
                    state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
                  }
                  if (error.response.status == 403) {
                    state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
                  }
                  if (error.response.status == 405) {
                    state.errors.push("同時にログインできる人数が上限に達しています。");
                  }
                })
            }
          }
        })
        .catch(error=>{
          if (error.response.status == 401) {
            state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
          }
          if (error.response.status == 402) {
            state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
          }
          if (error.response.status == 403) {
            state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
          }
          if (error.response.status == 405) {
            state.errors.push("同時にログインできる人数が上限に達しています。");
          }
          if (error.response.status == 406) {
            state.errors.push("現在メンテナンス中のためログインできません。");
          }
          if (error.response.status == 409) {
            state.errors.push("アカウントが無効になっているためログインできません。");
          }
          if (error.response.status == 411) {
            state.errors.push("入試・模試オプションが無効になっているため、入試・模試用ユーザーはログインできません。");
          }
        });

      context.root.$store.dispatch("hideOverlay");
    }

    // ログイン成功後の後処理
    const executeLogin = (response: any) => {

      // 2段階認証
      if (response.data.two_factor_auth) {
        // ログインIDをstateに保持
        context.root.$store.commit("setOtpLoginId", response.data.otp_login_id);
        context.root.$router.push(`/teacher_site/sign_in_two_factor`).catch(err => {});
        return
      }
      
      // トークン設定
      var token = response.data.user.access_token
      document.cookie = 'access_token=' + token;
      document.cookie = 'smarky_user_id=' + response.data.user.id;

      context.root.$store.commit("setCurrentUser", response.data.user);
      context.root.$store.commit("setSchools", response.data.schools);
      context.root.$store.commit("setCurriculums", response.data.curriculums);
      context.root.$store.commit("setViewPoints", response.data.view_points);
      context.root.$store.commit("setDefaultSheetType", response.data.default_sheet_type);

      if((response.data.user.role == Common.RoleEnum.Teacher1 || response.data.user.role == Common.RoleEnum.Teacher2) && response.data.user.login_count == 1) {
        // 通常試験用ユーザの初回ログインはパスワード設定画面へ遷移
        context.root.$router.push(`/teacher_site/user_edit`).catch(() => {});
      } else {
        if(response.data.user.role == Common.RoleEnum.EntranceTeacher1 || response.data.user.role == Common.RoleEnum.EntranceTeacher2){
          if(context.root.$store.getters.isOptionEntranceActive && context.root.$store.getters.isOptionPracticeActive){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(() => {});
          }else if(context.root.$store.getters.isOptionEntranceActive){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(() => {});
          }else if(context.root.$store.getters.isOptionPracticeActive){
            context.root.$router.push('/teacher_site/practice_sheet_list').catch(() => {});
          }else{
            state.errors.push("入試・模試オプションが無効になっているためログインできません。");
            return;
          }
        }else{
          // 入試ユーザ以外のログインはデフォルトの試験一覧へ
          if(response.data.default_sheet_type == Common.SheetTypeEnum.Entrance){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(() => {});
          }else if(response.data.default_sheet_type == Common.SheetTypeEnum.Cbt){
            context.root.$router.push('/teacher_site/cbt_sheet_list').catch(() => {});
          }else if(response.data.default_sheet_type == Common.SheetTypeEnum.Practice){
            context.root.$router.push('/teacher_site/practice_sheet_list').catch(() => {});
          }else{
            context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
          }
        }
      }
    }

    /******************************
     * Googleログイン
     ******************************/

    const googleLogin = async () => {
      window.location.href = `/api/classroom_sessions/authorize_sso?type=sso_teacher`;
    }

    /******************************
     * Windowsアカウントログイン
     ******************************/

    const azureLogin = async () => {
      window.location.href = `/api/azure_sessions/authorize_sso?type=sso_teacher`;
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      document.body.style.background = "whitesmoke";

      const url = window.location.href;
      const logoFileName =  state.isEntranceSite ? "logo_smarky_entrance_ol.png" : "logo_smarky_ol.png";
      context.root.$store.commit("setBase64SchoolLogo", require(`@/assets/images/${logoFileName}`));
      context.root.$store.commit("setNextFieldType", null);
      
      if(context.root.$route.query.error_kind){
        const error_kind = context.root.$route.query.error_kind as string;

        if(error_kind == "user_not_exists"){
          state.errors.push("お試しいただいたGoogleアカウントではログインできません。");
        }else if(error_kind == "user_not_exists_azure"){
          state.errors.push("お試しいただいたMicrosoftアカウントではログインできません。");
        }else if(error_kind == "mainte"){
          state.errors.push("現在メンテナンス中のためログインできません。");
        }else if(error_kind == "login_failed_not_active"){
          state.errors.push("アカウントが無効になっているためログインできません。");
        }else if(error_kind == "login_failed_count_over"){
          state.errors.push("ログイン失敗回数の制限を超えたためログインできません。管理者に問い合わせてください。");
        }else if(error_kind == "entrance_option_not_active"){
          state.errors.push("入試・模試オプションが無効になっているため、入試・模試用ユーザーはログインできません。");
        }else if(error_kind == "ip_address_error"){
          state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
        }else if(error_kind == "multiple_login_count_over"){
          state.errors.push("同時にログインできる人数が上限に達しています。");
        }else{
          state.errors.push("ログインに失敗しました。予期せぬエラーが発生しました。");
        }
      }
    })

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.background = "white";
    });

    return {
      ...toRefs(state),
      onSubmit,
      googleLogin,
      azureLogin,
    }
  }
})
